import { render } from "./CollectStatusView.vue?vue&type=template&id=75831db6&scoped=true"
import script from "./CollectStatusView.vue?vue&type=script&lang=js"
export * from "./CollectStatusView.vue?vue&type=script&lang=js"

import "./CollectStatusView.vue?vue&type=style&index=0&id=75831db6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75831db6"]])

export default __exports__